import {
    GETMAPPINGDEALERLIST_SUCCESS,
    GETMAPPINGDEALERLIST_FAILED,
    RESET_GETMAPPINGDEALERLIST,
    LOADING_GETMAPPINGDEALERLIST,
    NETWORK_ERROR_GETMAPPINGDEALERLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMAPPINGDEALERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMAPPINGDEALERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMAPPINGDEALERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMAPPINGDEALERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMAPPINGDEALERLIST:
            return (state = initialState);
        default:
            return state;
    }
};